<div class="admin-preview-container" *ngIf="adminDisplay || uncorrectedUrl || displayPageFalse">
  <span *ngIf="adminDisplay">Preview only for admin</span>
  <span *ngIf="uncorrectedUrl">Uncorrected Url</span>
  <span *ngIf="displayPageFalse">Display page false</span>
</div>
